export default __webpack_public_path__ + "static/media/arrow-D.4f2bb7a1.svg";